import {
  ACTIVITY_STATUS_LABELS,
  ACTIVITY_STATUS_ORDER,
  FACILITY_INSTALLATION_BUSINESS_SERVICE,
  fetchWorkflowBusinessService,
  tenantId as getTenantId,
  translateOr,
  useAuthStore,
  useTranslate,
  type ActivityStatus,
} from "@/shared";
import { useQuery } from "@tanstack/react-query";
import type { ActivityFilterOption } from "../components/activity/ActivityFilter";

export function useActivityStatusOptions() {
  const { t } = useTranslate();
  const accessToken = useAuthStore((state) => state.accessToken);
  const user = useAuthStore((state) => state.user);
  const employeeTenantId = useAuthStore((state) => state.employeeTenantId);
  const tenantId = employeeTenantId || getTenantId();

  const { data, isLoading } = useQuery({
    queryKey: ["ir-activity-installation-states", tenantId],
    enabled: Boolean(accessToken),
    staleTime: 5 * 60_000,
    queryFn: () =>
      fetchWorkflowBusinessService(
        tenantId,
        FACILITY_INSTALLATION_BUSINESS_SERVICE,
        accessToken!,
        user,
      ),
  });

  const availableCodes = new Set(
    (data?.BusinessServices?.[0]?.states ?? [])
      .map((state) => state.applicationStatus)
      .filter((status): status is ActivityStatus => Boolean(status)),
  );

  const options: ActivityFilterOption[] = ACTIVITY_STATUS_ORDER.filter((status) =>
    availableCodes.has(status),
  ).map((status) => {
    const label = ACTIVITY_STATUS_LABELS[status];
    return { code: status, name: translateOr(t, label.key, label.fallback) };
  });

  return { options, isLoading };
}
